import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { tzmoment } from 'lib/tzmoment';
import { CruiseSchedule } from './cruiseschedule';
import { GoToPortCall } from './model';
import { LoadingIcon } from './loadingicon';
import { PCTooltip } from 'portcall/pctooltip/view';

export const CruiseScheduleView = SuperCritical(({ model, goToPortCall, domainUOM } : { model: CruiseSchedule, goToPortCall : GoToPortCall, domainUOM : string }) =>
    <div className="homepage-cruiseschedule">
        <LoadingIcon loading = {model.Loading} />
        <ul>
            {model.PortCruiseSchedules().map(c => 
                <li className="port-group" key={c.Data.PortId}>
                    <div className="port-name">{c.Data.PortName}</div>
                    <ul className="cruise-list">
                        {c.CruiseVisitYears.map(([year, visits]) =>
                            <li key={year}>
                                <div className="year">
                                    {year}
                                </div>
                                {visits.map(v =>
                                    <div className="cruise" onClick = {e => goToPortCall(v.Data)} key={v.Data.ReservationId}>
                                        <div className="cruise-subsection">
                                            <div className="cruise-col-dates">
                                                <div className="arrival">{tzmoment(v.Arrival).format('DD MMM - HH:mm')}</div>
                                                <div className="departure">dep {tzmoment(v.Departure).format(v.DepartsOnSameDayAsArrival() ? 'HH:mm' : 'DD MMM HH:mm')}</div>
                                            </div>
                                            <div className="cruise-col-vessel-details">
                                                <PCTooltip title={() => v.Data.VesselName || ''} className="cruise-col-tooltip">
                                                    <div className="vessel">{v.Data.VesselName}</div>
                                                </PCTooltip>
                                                {model.isAruba() ? 
                                                    <div className="particulars">
                                                        <span className="length secondary-text">{v.Length.convert(domainUOM).toString()}</span>
                                                    </div>
                                                    : 
                                                    <div className="particulars">
                                                        <span className="length secondary-text">{v.Length.convert(domainUOM).toString()}</span>
                                                        <span className="pipe light-text secondary-text"> | </span>
                                                        <span className="guests secondary-text">{v.Data.ExpectedPassengerCount === null ? '' : v.Data.ExpectedPassengerCount + ' guests'}</span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className="cruise-subsection reservation-details">
                                            <div className="cruise-col-reservation-details">
                                                <PCTooltip title={() => v.Data.BerthName || ''} className="cruise-col-tooltip">
                                                    <div className="berth">{v.Data.BerthName}</div>
                                                </PCTooltip>
                                                <div className="last-port">
                                                    <span className="light-text secondary-text">last port</span>
                                                    <span className="pipe light-text secondary-text"> | </span>
                                                    <div className="last-location secondary-text">{v.Data.LastPortOfCall || '\u2014' /* em-dash */}</div>
                                                </div>
                                            </div>
                                            <div className="cruise-col-reservation-status">
                                                {v.Data.ReservationStatus === 3 ? 'Conflicted' :
                                                 v.Data.ReservationStatus === 1 ? 'Booked' : 
                                                 'Requested'}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </li>
                        )}
                    </ul>
                </li>
            )}
        </ul>
    </div>);


// WEBPACK FOOTER //
// ./apps/portcall/homepage/cruisescheduleview.tsx